import React from 'react'
import {Waypoint} from 'react-waypoint'
import './style.css'

export default class WhenInView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isInView: false
    }

    this.onEnter = this.onEnter.bind(this)
    this.onLeave = this.onLeave.bind(this)
  }

  onEnter() {
    this.setState({
      isInView: true
    })
  }

  onLeave() {
    this.setState({
      isInView: false
    })
  }

  render() {
    return (
      <div>
        <Waypoint
          onEnter={this.onEnter}
          onLeave={this.onLeave}
          topOffset='-550'
          bottomOffset='-550'
        />
        {this.state.isInView ? (
          this.props.children
        ) : (
          <div className='placeholder' />
        )}
      </div>
    )
  }
}
